import React from 'react';
import Spin from 'antd/lib/spin';
var BlockUi = function (props) {
    return (React.createElement(Spin, { spinning: props.isBlocked }, props.children));
};
export default BlockUi;



//////////////////
// WEBPACK FOOTER
// ./src/containers/BlockUi/BlockUi.tsx
// module id = 1521
// module chunks = 0